<div class="content-panel">
  <div class="row header">
    <div class="col col-lg-12">
      <div class="row" style="margin: 0">
        <div class="col-3 col-lg-12 divProductImage">
          @if (productImageUrl()) {
            <img
              class="align-middle"
              id="productImage"
              [src]="productImageUrl()"
              [alt]="'GAST-PORTAL-NG.CONTENT_PANEL.PRODUCT_IMAGE' | translate" />
          }
        </div>
        <div class="col-6 col-lg-12">
          @if (headerTitle()) {
            <h4 class="align-middle portal-text" [innerHtml]="headerTitle()"></h4>
          }
        </div>

        <div class="col-3 col-lg-12 divProductName">
          @if (productNameTitle()) {
            <h5 class="align-middle portal-text" [innerHtml]="productNameTitle()"></h5>
          }
        </div>

        @if (headerImageUrl()) {
          <img [alt]="'GAST-PORTAL-NG.CONTENT_PANEL.HEADER_IMAGE' | translate" [src]="headerImageUrl()" />
        }
      </div>
    </div>
  </div>

  <div class="row content" style="flex: 2">
    <div class="col col-12">
      <div>
        <ng-content></ng-content>
      </div>
    </div>
  </div>

  @if (footerUrl() || footerButtonText() || footerButton2Text()) {
    <div class="row footer">
      <div class="col col-12">
        <div>
          @if (footerUrl() && footerUrlText()) {
            <a [href]="footerUrl()">
              {{ footerUrlText() }}
            </a>
          }

          @if (footerButtonText()) {
            <button
              class="btn btn-outline-secondary mr-2"
              [disabled]="buttonDisabled()"
              (click)="footerButtonClicked()">
              {{ footerButtonText() }}
            </button>
          }

          @if (footerButton2Text()) {
            <button class="btn btn-outline-secondary" [disabled]="button2Disabled()" (click)="footerButton2Clicked()">
              {{ footerButton2Text() }}
            </button>
          }
        </div>
      </div>
    </div>
  }
</div>
